//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.FeatureGeomBuilder.js";
import "../CAM/CAM.GeometryGroup.js";
import "../CAM/CAM.Geometry.js";
import "../CAM/CAM.PartAxisBuilder.js";
let d=[[[0,"AxisOfRotation",1,0],[1,"BlankGeometry",0,"CAM.GeometryGroup",0],[1,"CheckGeometry",0,"CAM.Geometry",0],[1,"FloorGeometry",0,"CAM.Geometry",0],[1,"PartAxisBuilder",0,"CAM.PartAxisBuilder",0],[0,"PartAxisPoint",1,"Point",0],[0,"PartAxisVector",1,"Direction",0],[1,"PartGeometry",0,"CAM.Geometry",0],[1,"WallGeometry",0,"CAM.Geometry",0]],[],[]];
SPLM.CAM.RotaryFinishGeomBuilder = class extends SPLM.CAM.FeatureGeomBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.RotaryFinishGeomBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.RotaryFinishGeomBuilder.PartAxisOfRotationTypes = Object.freeze({
    "Zm" : "Zm", "Specify" : "Specify", "Xm" : "Xm", "Ym" : "Ym"});

export default SPLM;